import { $http } from "@/assets/js/appFunc";

// load items - perspective builder
export const actGetPerspectives = (store, searchValue) => {
    const processDefinitionId = store.rootState.main.currentApplicationId;
    const querryParam = searchValue ? `?searchValue=${searchValue}` : "";
    const params = {
        url: `/engine/apps/${processDefinitionId}/perspectives${querryParam}`,
        type: "GET"
    };
    return $http(params, true);
};

// load items - case search perspective
export const actGetCasePerspectives = (store, searchValue) => {
    const processDefinitionId = store.rootState.main.currentApplicationId;
    const querryParam = searchValue ? `?searchValue=${searchValue}` : "";
    const params = {
        url: `/engine/apps/${processDefinitionId}/consume/perspectives${querryParam}`,
        type: "GET"
    };
    return $http(params, true);
};

export const actSavePerspective = (store, payload) => {
    const processDefinitionId = store.rootState.main.currentApplicationId;
    const params = {
        url: `/engine/apps/${processDefinitionId}/perspectives`,
        type: "POST",
        data: payload
    };
    return $http(params, true);
};

// get perspective details - perspective builder
export const actLoadPerspectiveData = (store, perspectiveId) => {
    const processDefinitionId = store.rootState.main.currentApplicationId;
    const params = {
        url: `/engine/apps/${processDefinitionId}/perspectives/${perspectiveId}`,
        type: "GET"
    };
    return $http(params, true);
};

// get perspective details - case search
export const actLoadCasePerspectiveData = (store, perspectiveId) => {
    const processDefinitionId = store.rootState.main.currentApplicationId;
    const params = {
        url: `/engine/apps/${processDefinitionId}/consume/perspectives/${perspectiveId}`,
        type: "GET",
        noNotify: true
    };
    return $http(params, true);
};

export const actDeletePerspective = (store, perspectiveId) => {
    const processDefinitionId = store.rootState.main.currentApplicationId;
    const params = {
        url: `/engine/apps/${processDefinitionId}/perspectives/${perspectiveId}`,
        type: "DELETE"
    };
    return $http(params, true);
};
